import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const KeyIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 21.8099V25.7025C1 26.481 1.51901 27 2.29752 27H7.48759V23.1074H11.3801V19.2149H13.9752L15.7917 17.3984C17.5951 18.0265 19.5582 18.0241 21.36 17.3916C23.1618 16.759 24.6956 15.5336 25.7104 13.916C26.7253 12.2984 27.1611 10.3842 26.9466 8.48666C26.7322 6.58913 25.8801 4.82054 24.5298 3.47024C23.1795 2.11993 21.4109 1.26785 19.5133 1.05337C17.6158 0.838901 15.7016 1.27474 14.084 2.28959C12.4664 3.30444 11.241 4.83821 10.6084 6.64001C9.97585 8.44181 9.97345 10.4049 10.6016 12.2083L1 21.8099Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8148 8.83487C20.1731 8.83487 20.4635 8.54441 20.4635 8.18611C20.4635 7.82781 20.1731 7.53735 19.8148 7.53735C19.4565 7.53735 19.166 7.82781 19.166 8.18611C19.166 8.54441 19.4565 8.83487 19.8148 8.83487Z"
        fill="white"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default KeyIcon;

KeyIcon.propTypes = customIconsPropTypes;
